import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { BasketService } from '../shared/basket.service'
import { CommandeLine } from '../shared/commande-line'

@Component({
  selector: 'app-commande-line',
  templateUrl: './commande-line.component.html',
  styleUrls: ['./commande-line.component.scss']
})
export class CommandeLineComponent implements OnInit {

  @Input()
  commandeLine: CommandeLine

  @Output()
  public deleted: EventEmitter<CommandeLine> = new EventEmitter()

  constructor(private basketService: BasketService) {

  }

  ngOnInit() {

  }



  deleteLine() {
    this.basketService.deleteBasketLine(this.commandeLine).subscribe(values =>
      this.deleted.next(this.commandeLine)
    )
  }

  notifyBeforeDelete() {
    return !this.commandeLine.date || new Date(this.commandeLine.date) < new Date(new Date().setHours(0, 0, 0))
  }
}
